import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function redirect(url) {
  return (
    <Route render={({ staticContext }) => {
      if (staticContext) staticContext.status = 301;
      return <Redirect to={`${url}`} />;
    }}
    />
  );
}

export default redirect;
